import { Component, Input, OnInit} from '@angular/core';
import { forkJoin } from 'rxjs';
import { Aviso } from 'src/app/model/Aviso';
import { DocumentoPac } from 'src/app/model/DocumentoPac';
import { HistoricoTransacoesRealizadasView } from 'src/app/model/view/HistoricoTransacoesReralizadasView';
import { PacService } from 'src/app/services/pac.service';

@Component({
  selector: 'app-informacoes-do-historico',
  templateUrl: './informacoes-do-historico.component.html',
  styleUrls: ['./informacoes-do-historico.component.scss'],
  standalone: false
})
export class InformacoesDoHistoricoComponent implements OnInit {


  @Input() documentoPac: DocumentoPac = new DocumentoPac();
  
  historicos:HistoricoTransacoesRealizadasView[] = []
  avisosAnalise: Aviso[]
  avisosProtocolo: Aviso[]
  
  constructor(private pacService: PacService) { }
  
  ngOnInit(): void {
    if(this.documentoPac){
      forkJoin({
        hist: this.pacService.buscarHistorico(this.documentoPac.id, "PAC"),
        avisosAnalise: this.pacService.buscarAvisosAnalisePac(this.documentoPac.id),
        avisosProtocolo: this.pacService.buscarAvisosProtocoloPac(this.documentoPac.id)
      }).subscribe(resultado => {
        this.historicos = resultado.hist
        this.avisosAnalise = resultado.avisosAnalise.length > 0 ? resultado.avisosAnalise : undefined
        this.avisosProtocolo = resultado.avisosProtocolo.length > 0 ? resultado.avisosProtocolo : undefined
      })
    }
  }
}
